var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Solid/users",
    clipPath: "url(#clip0_1563_63040)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.19883 5.29941C7.19883 6.6249 6.12431 7.69941 4.79883 7.69941C3.47334 7.69941 2.39883 6.6249 2.39883 5.29941C2.39883 3.97393 3.47334 2.89941 4.79883 2.89941C6.12431 2.89941 7.19883 3.97393 7.19883 5.29941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5988 5.29941C13.5988 6.6249 12.5243 7.69941 11.1988 7.69941C9.87334 7.69941 8.79883 6.6249 8.79883 5.29941C8.79883 3.97393 9.87334 2.89941 11.1988 2.89941C12.5243 2.89941 13.5988 3.97393 13.5988 5.29941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3421 14.0994C10.3795 13.8381 10.3988 13.571 10.3988 13.2994C10.3988 11.9913 9.9503 10.7879 9.19863 9.83467C9.78703 9.49425 10.4702 9.29941 11.1988 9.29941C13.408 9.29941 15.1988 11.0903 15.1988 13.2994V14.0994H10.3421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.79883 9.29941C7.00797 9.29941 8.79883 11.0903 8.79883 13.2994V14.0994H0.798828V13.2994C0.798828 11.0903 2.58969 9.29941 4.79883 9.29941Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1563_63040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.fe9056e6a338711d0a03aa1d528956e8.svg";
export { ForwardRef as ReactComponent };